import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from './security.service';

/**
 * Pages for organization admins only (today: Finances, which is admin-only in the side menu).
 * Anyone else typing the address lands on Home. The menu hides the entry as well; this closes the
 * address, which the mockup asked for before Finances is released.
 */
export const orgAdminGuard: CanActivateFn = () => {
  const security = inject(SecurityService).securityObject;
  return security?.isAdmin ? true : inject(Router).createUrlTree(['/home']);
};
